import ConfirmDeleteModal from "./ConfirmDeleteModal";
export * from "./ConfirmDeleteModal";
export default ConfirmDeleteModal;